import React, { ReactNode, useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { SplashScreen } from '@berriesflow/core';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { useAtomValue } from 'jotai';

import { _storeLocale } from './_storeLocale';
import { locales, localesDayjs } from './locales';

dayjs.extend(localizedFormat);

// Seules langues de droite à gauche parmi les 18 locales.
const rtlLocales = ['ar'];

interface Props {
  children: ReactNode;
}

export default function InitLocale({ children }: Props) {
  const locale = useAtomValue(_storeLocale);
  const [text, setText] = useState<any>(null);

  useEffect(() => {
    if (locale) {
      locales[locale]().then((data: any) => {
        setText(data['default']);
      });

      localesDayjs[locale]().then(() => {
        dayjs.locale(locale);
      });

      // Sans ça la page reste annoncée en français et l'arabe s'affiche de gauche à droite.
      document.documentElement.lang = locale;
      document.documentElement.dir = rtlLocales.includes(locale)
        ? 'rtl'
        : 'ltr';
    }
  }, [locale]);

  return (
    <>
      {text !== null && !!locale ? (
        <IntlProvider
          locale={locale}
          messages={text}
        >
          {children}
        </IntlProvider>
      ) : (
        <SplashScreen />
      )}
    </>
  );
}
